import React from "react"
import classNames from "classnames"
import "./box.scss"

const Box = props => {
    const classnames = classNames(`m-box`, {
        //colors
        "m-box--white": props.white,
        "m-box--bg-pr": props.bgPr,

        //custom
        "m-box--border": props.border,
    });
    return (
        <div className={props.className ? props.className + ` ` + classnames : classnames}>
            {props.children}
        </div>
    )
}

export default Box
